import { render, staticRenderFns } from "./GoogleAuthButton.vue?vue&type=template&id=15b2927a&scoped=true&"
import script from "./GoogleAuthButton.vue?vue&type=script&lang=ts&"
export * from "./GoogleAuthButton.vue?vue&type=script&lang=ts&"
import style0 from "./GoogleAuthButton.vue?vue&type=style&index=0&id=15b2927a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b2927a",
  null
  
)

export default component.exports